export enum LocationEventType {
  Outage = 0,
  Closed = 1
}

export class LocationEventViewModel {
  id?: string;
  locationId: string;
  startDate: Date;
  endDate: Date;
  locationEventType: LocationEventType;
  notes: string;
  dateCreatedUtc?: Date;
  dateDeletedUtc?: Date;
}

